import React, {Component} from 'react';
import {NavLink, withRouter} from 'react-router-dom';
import {Sidebar} from './style';
import {AddButton} from '../../../../components/addButton';

class ToolsSidebar extends Component{
	constructor(props) {
		super(props);

		this.state = {
			hasShadow: false,
		}

		this.onScroll = this.onScroll.bind(this);
	}

	onScroll(event) {
		if (event.target.scrollTop >= 10) {
			this.setState({hasShadow: true});
		} else {
			this.setState({hasShadow: false});
		}
	}

	renderItem(item, path, key) {
		const {history} = this.props;
		const link = (item.link && (typeof item.link == 'function' ? item.link(history) : item.link));
		
		return (
			<NavLink 
				key={key}
				to={link || '#'} 
				className={(path === link) ? 'list-item-active' : ''}				
				title={item.title}>
				<li>
					<i className={'icon ' + (item.icon || 'mapsa-home')}/>
					<span className="list-item-text">{item.title}</span>							
				</li>
			</NavLink>
		);
	}

	render() {
		const {onAddClick, addButton, menu, SubComponent, history} = this.props;
		const {pathname, search} = this.props.history.location;
		const {hasShadow} = this.state;		
		const disable = addButton.disable && 
							(typeof addButton.disable == 'function' ? addButton.disable(history) : addButton.disable);

		return(
			<Sidebar onScroll={this.onScroll} expand>
				<AddButton				 
					hasShadow={hasShadow} 
					title={ (addButton && addButton.title) || "افزودن" } 
					onClick={() => onAddClick && !disable && onAddClick()}
					disable={disable} 					
					style={{position: "sticky", top: 0}}
					expand 
				/>
				<div className="sidebar-list">		
					<ul>
						{
							menu && menu.map((item, index) => this.renderItem(item, pathname+search, index))
						}
					</ul>
					{ SubComponent }
				</div>
			</Sidebar>
			)  
	}
} 

export default withRouter(ToolsSidebar);